export default {
  en: {
    messages: {
      title: "Contact Support",
      loading: "Loading...",
      issueType: "What is your question about?",
      chooseTopicPrompt: "Choose a topic to continue.",
      requestedTopicUnavailable: "The requested topic is not available. Choose a topic below or sign in to access more topics.",
      subject: "Subject",
      subjectPlaceholder: "A short summary of your issue",
      priority: "Priority",
      priorityLow: "Low",
      priorityNormal: "Normal",
      priorityHigh: "High",
      priorityUrgent: "Urgent",
      description: "Description",
      descriptionPlaceholder: "Please describe your issue in detail (at least a few sentences)",
      email: "Your email address",
      emailHint: "We'll use this to follow up and to send your ticket confirmation.",
      signedInAs: "Submitting as {0}",
      signInPrompt: "Have an account?",
      signIn: "Sign in",
      signInBenefit: "to skip re-entering your email and unlock more issue types.",
      submit: "Submit ticket",
      reviewAndSubmit: "Review and submit",
      reviewTicket: "Review ticket",
      reviewAgain: "Review again",
      submitting: "Submitting...",
      checkingTicket: "Reviewing your request...",
      useAiReview: "Use our AI review process to suggest additional information and immediate answers.",
      aiPrivacyNotice: "AI review is optional. Secrets and contact details are redacted where possible, and you choose whether to submit after seeing the review.",
      aiReviewResultTitle: "AI review results",
      aiPossibleAnswerTitle: "This might answer your question",
      aiMissingInfoTitle: "A few more details would help",
      aiMissingInfoFallback: "Consider adding more detail about your issue before submitting.",
      aiSuggestedTemplateTitle: "A better template may fit this request",
      aiSuggestedTemplateBody: "Suggested template: {0}",
      aiUseSuggestedTemplate: "Use this template",
      aiLooksGood: "Your ticket looks ready to submit.",
      aiAnswerHelped: "This answers my question",
      aiGoBack: "Go back and add more detail",
      aiSubmitAnyway: "Submit anyway",
      aiAnsweredThanks: "Glad we could help! Let us know if you need anything else.",
      requiresSignIn: "This topic requires signing in to your account.",
      miscategorizationHint: "This looks like it might need more technical detail - consider switching to a more specific category above so we can help faster.",
      successTitle: "Ticket submitted",
      successBody: "Your support ticket #{0} has been created. We'll be in touch by email.",
      notConfirmedTitle: "Submission not confirmed",
      notConfirmedBody: "We couldn't confirm that your ticket was created. Please try again, or email us directly at support@visualcrossing.com if it keeps happening.",
      tryAgain: "Try again",
      viewTicket: "View ticket",
      submitAnother: "Submit another ticket",
      errorGeneric: "Something went wrong submitting your ticket. Please try again.",
      errorRateLimited: "Too many tickets submitted. Please try again later.",
      fieldRequired: "Required",
      attachments: "Attachments",
      addAttachment: "Attach files",
      removeAttachment: "Remove",
      attachmentUploading: "Uploading...",
      attachmentTooLarge: "That file is too large (max 15 MB).",
      attachmentLimitHint: "Up to {0} files, 15 MB each.",
      testQueryUrl: "Test request",
      testingQueryUrl: "Testing...",
      queryTestSuccess: "Request succeeded",
      queryTestHttpError: "Request returned an error status",
      queryTestFailed: "Request failed",
      queryTestTimeout: "Request timed out after 20 seconds.",
      newTicket: "New ticket",
      openNewTicket: "Open new ticket",
      myTickets: "My Tickets",
      noTickets: "No support tickets yet.",
      noOpenTickets: "You have no open tickets.",
      filterOpen: "Open",
      filterAll: "All",
      loadMore: "Load more",
      recentlyClosed: "Recently closed",
      backToList: "Back to my tickets",
      ticketNumber: "Ticket #{0}",
      statusOpen: "We're on it",
      statusPending: "Awaiting our reply",
      statusHold: "We're on it",
      statusSolved: "Closed",
      statusClosed: "Closed",
      statusNew: "Submitted",
      reply: "Reply",
      replyPlaceholder: "Add a reply...",
      sendReply: "Send reply",
      sending: "Sending...",
      closedNotice: "This ticket is closed.",
      loadFailed: "Unable to load this right now. Please try again.",
      refresh: "Refresh",
      you: "You",
      agent: "Support agent",
    },
  },
  de: {
    messages: {
      title: "Support kontaktieren",
      loading: "Wird geladen...",
      issueType: "Worum geht es in Ihrer Frage?",
      chooseTopicPrompt: "Wählen Sie ein Thema aus, um fortzufahren.",
      requestedTopicUnavailable: "Das angeforderte Thema ist nicht verfügbar. Wählen Sie unten ein Thema aus oder melden Sie sich an, um auf weitere Themen zuzugreifen.",
      subject: "Betreff",
      subjectPlaceholder: "Eine kurze Zusammenfassung Ihres Anliegens",
      priority: "Priorität",
      priorityLow: "Niedrig",
      priorityNormal: "Normal",
      priorityHigh: "Hoch",
      priorityUrgent: "Dringend",
      description: "Beschreibung",
      descriptionPlaceholder: "Bitte beschreiben Sie Ihr Anliegen im Detail (mindestens ein paar Sätze)",
      email: "Ihre E-Mail-Adresse",
      emailHint: "Wir verwenden dies, um nachzufassen und Ihnen die Ticketbestätigung zu senden.",
      signedInAs: "Einreichen als {0}",
      signInPrompt: "Haben Sie ein Konto?",
      signIn: "Anmelden",
      signInBenefit: "um die erneute Eingabe Ihrer E-Mail zu überspringen und mehr Themen freizuschalten.",
      submit: "Ticket senden",
      reviewAndSubmit: "Prüfen und senden",
      reviewTicket: "Ticket prüfen",
      reviewAgain: "Erneut prüfen",
      submitting: "Wird gesendet...",
      checkingTicket: "Ihre Anfrage wird geprüft...",
      useAiReview: "Unseren KI-Prüfprozess verwenden, um zusätzliche Informationen und sofortige Antworten vorzuschlagen.",
      aiPrivacyNotice: "Die KI-Prüfung ist optional. Geheimnisse und Kontaktdaten werden nach Möglichkeit entfernt, und Sie entscheiden nach der Prüfung, ob Sie senden.",
      aiReviewResultTitle: "Ergebnisse der KI-Prüfung",
      aiPossibleAnswerTitle: "Das könnte Ihre Frage beantworten",
      aiMissingInfoTitle: "Ein paar weitere Details wären hilfreich",
      aiMissingInfoFallback: "Erwägen Sie, vor dem Senden weitere Details zu Ihrem Anliegen hinzuzufügen.",
      aiSuggestedTemplateTitle: "Eine bessere Vorlage könnte zu dieser Anfrage passen",
      aiSuggestedTemplateBody: "Vorgeschlagene Vorlage: {0}",
      aiUseSuggestedTemplate: "Diese Vorlage verwenden",
      aiLooksGood: "Ihr Ticket ist bereit zum Senden.",
      aiAnswerHelped: "Das beantwortet meine Frage",
      aiGoBack: "Zurück und mehr Details ergänzen",
      aiSubmitAnyway: "Trotzdem senden",
      aiAnsweredThanks: "Freut uns, dass wir helfen konnten! Melden Sie sich, falls Sie noch etwas benötigen.",
      requiresSignIn: "Für dieses Thema ist eine Anmeldung erforderlich.",
      miscategorizationHint: "Dies scheint mehr technische Details zu benötigen - erwägen Sie, oben zu einer spezifischeren Kategorie zu wechseln, damit wir schneller helfen können.",
      successTitle: "Ticket gesendet",
      successBody: "Ihr Support-Ticket #{0} wurde erstellt. Wir melden uns per E-Mail.",
      notConfirmedTitle: "Übermittlung nicht bestätigt",
      notConfirmedBody: "Wir konnten nicht bestätigen, dass Ihr Ticket erstellt wurde. Bitte versuchen Sie es erneut oder schreiben Sie uns direkt an support@visualcrossing.com, falls das Problem weiterhin auftritt.",
      tryAgain: "Erneut versuchen",
      viewTicket: "Ticket ansehen",
      submitAnother: "Weiteres Ticket senden",
      errorGeneric: "Beim Senden Ihres Tickets ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      errorRateLimited: "Zu viele Tickets gesendet. Bitte versuchen Sie es später erneut.",
      fieldRequired: "Erforderlich",
      attachments: "Anhänge",
      addAttachment: "Dateien anhängen",
      removeAttachment: "Entfernen",
      attachmentUploading: "Wird hochgeladen...",
      attachmentTooLarge: "Diese Datei ist zu groß (max. 15 MB).",
      attachmentLimitHint: "Bis zu {0} Dateien, je 15 MB.",
      testQueryUrl: "Anfrage testen",
      testingQueryUrl: "Wird getestet...",
      queryTestSuccess: "Anfrage erfolgreich",
      queryTestHttpError: "Anfrage gab einen Fehlerstatus zurück",
      queryTestFailed: "Anfrage fehlgeschlagen",
      queryTestTimeout: "Zeitüberschreitung nach 20 Sekunden.",
      newTicket: "Neues Ticket",
      openNewTicket: "Neues Ticket öffnen",
      myTickets: "Meine Tickets",
      noTickets: "Noch keine Support-Tickets.",
      noOpenTickets: "Sie haben keine offenen Tickets.",
      filterOpen: "Offen",
      filterAll: "Alle",
      loadMore: "Mehr laden",
      recentlyClosed: "Kürzlich geschlossen",
      backToList: "Zurück zu meinen Tickets",
      ticketNumber: "Ticket #{0}",
      statusOpen: "Wir kümmern uns darum",
      statusPending: "Wartet auf unsere Antwort",
      statusHold: "Wir kümmern uns darum",
      statusSolved: "Geschlossen",
      statusClosed: "Geschlossen",
      statusNew: "Gesendet",
      reply: "Antworten",
      replyPlaceholder: "Antwort hinzufügen...",
      sendReply: "Antwort senden",
      sending: "Wird gesendet...",
      closedNotice: "Dieses Ticket ist geschlossen.",
      loadFailed: "Kann gerade nicht geladen werden. Bitte versuchen Sie es erneut.",
      refresh: "Aktualisieren",
      you: "Sie",
      agent: "Support-Mitarbeiter",
    },
  },
};
